import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={8} height={12} viewBox="0 0 8 12" {...props}>
      <title>{"Path 3"}</title>
      <path d="M1 11.293l5.223-5.037L1 1" stroke="#1D1D1D" strokeWidth={2} fill="none" fillRule="evenodd" />
    </svg>
  )
}

const ChevronArrowRightIcon = React.memo(SvgComponent)

ChevronArrowRightIcon.displayName = "ChevronArrowRightIcon"

export default ChevronArrowRightIcon
